import { render, staticRenderFns } from "./ClanTree.vue?vue&type=template&id=5350f8f6&"
import script from "./ClanTree.vue?vue&type=script&lang=js&"
export * from "./ClanTree.vue?vue&type=script&lang=js&"
import style0 from "./ClanTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports